namespace GeniuzPOS.QRreport {
    export class QRyStockcardColumns {
        static columnsKey = 'QRreport.QRyStockcard';
    }
}
